import { createFileRoute } from "@tanstack/react-router";
import { Login } from "@/features/auth/login/Login";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/login")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("ログイン");

  return <Login />;
}
